import { useRef, useEffect, useState } from 'react';
import QRCode from 'qrcode';

import { Modal, SecondaryButton } from '../../components';
import css from './ListingPage.module.css';

const SectionQrCode = () => {
  const modalCanvasRef = useRef(null);
  const [modalQrCodeDataURL, setModalQrCodeDataURL] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (modalCanvasRef.current && isModalOpen && typeof window !== 'undefined') {
      // Generate large QR code for modal
      const listingURL = window.location.href;

      QRCode.toCanvas(modalCanvasRef.current, listingURL, {
        width: 200,
        margin: 2,
      }, (error) => {
        if (error) {
          console.error('Modal QR Code generation error:', error);
        } else {
          setModalQrCodeDataURL(modalCanvasRef.current.toDataURL('image/png'));
        }
      });
    }
  }, [isModalOpen]);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDownload = () => {
    if (modalQrCodeDataURL) {
      // Convert canvas data URL to blob
      fetch(modalQrCodeDataURL)
        .then(res => res.blob())
        .then(blob => {
          // Create object URL from blob
          const url = URL.createObjectURL(blob);

          // Create download link
          const link = document.createElement('a');
          link.href = url;
          link.download = `listing-qr-code.png`;

          // Trigger download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Clean up object URL
          URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Download failed:', error);
        });
    }
  };

  return (
    <>
      <div className={css.sectionQrCode}>
        <button
          className={css.qrCodeButton}
          onClick={handleModalOpen}
          title="Click to view QR code"
          type="button"
        >
          <img
            src="/static/icons/qr-code-icon.svg"
            alt="QR Code"
            className={css.qrCodeIcon}
          />
        </button>
      </div>

      <Modal
        id="QrCodeModal"
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onManageDisableScrolling={() => {}}
      >
        <div className={css.qrCodeModal}>
          <canvas
            ref={modalCanvasRef}
            className={css.qrCodeModalCanvas}
          />
          <SecondaryButton
            className={css.qrCodeDownloadButton}
            onClick={handleDownload}
          >
            Download QR Code
          </SecondaryButton>
        </div>
      </Modal>
    </>
  );
};

export default SectionQrCode;